import React, { createContext, useState, useContext, useEffect } from "react";
import { adminDetails, fetchUser } from "../api/fetch";
import Swal from "sweetalert";
// Create a Context for authentication
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isSignInOpen, setIsSignInOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [customerUser, setCustomerUser] = useState(null);
  const [drv, setDrv] = useState(null);

  console.log("User ::", user);
  console.log("Customer User ::", customerUser);

  useEffect(() => {
    const initializeSession = async () => {
      await Promise.all([checkSession(), checkUserSession()]);
      setIsLoading(false);
    };

    initializeSession();
  }, []);

  const checkUserSession = async () => {
    const authToken = localStorage.getItem("userToken");
    console.log("CUSTOME TOKENN ::", authToken);

    if (!authToken?.length) return;

    try {
      if (authToken?.length) {
        await fetchUser(authToken).then((res) => {
          console.log("RESSS CUSTOMERR ::", res);
          if (res?.status) {
            setCustomerUser(res?.user);
            setIsLoading(false);
          } else {
            localStorage.clear();
            setCustomerUser(null);
            window.location.href = "/";
            setIsLoading(false);
            // Swal({
            //   title: res?.msg,
            //   icon: "error",
            //   timer: 1000,
            // });
          }
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log("Error ::", error);
    }
  };

  const checkSession = async () => {
    const authToken = localStorage.getItem("adminToken");
    console.log("Locall ::", authToken);

    if (!authToken?.length) return;

    try {
      if (authToken?.length) {
        await adminDetails(authToken).then((res) => {
          if (res?.status) {
            setUser(res?.user);
            setIsLoading(false);
            if (window.location.pathname !== "/Dashboard") {
              window.location.href = "/Dashboard";
            }
          } else {
            localStorage.clear();
            setUser(null);
            window.location.href = "/";
            setIsLoading(false);
            Swal({
              title: res?.msg,
              icon: "error",
              timer: 1000,
            });
          }
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log("Error ::", error);
    }
  };

  const login = () => setIsAuthenticated(true);
  const logout = () => setIsAuthenticated(false);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login,
        logout,
        user,
        setUser,
        customerUser,
        setCustomerUser,
        checkSession,
        isLoading,
        setIsLoading,
        drv,
        setDrv,
        isSignInOpen,
        setIsSignInOpen,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
